import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fetchPackages = () => axios.get(`${API}/packages`).then((r) => r.data);

export const fetchPackage = (slug) =>
  axios.get(`${API}/packages/${slug}`).then((r) => r.data);

export const createCheckout = (items) =>
  axios
    .post(`${API}/payments/checkout`, {
      items: items.map((i) => ({ package_slug: i.slug, quantity: i.quantity })),
      origin_url: window.location.origin,
    })
    .then((r) => r.data);

export const fetchPaymentStatus = (sessionId) =>
  axios.get(`${API}/payments/status/${sessionId}`).then((r) => r.data);

export const fetchReceipt = (sessionId) =>
  axios.get(`${API}/payments/receipt/${sessionId}`).then((r) => r.data);

export const formatPrice = (value) =>
  new Intl.NumberFormat("it-IT", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
